import moment from 'moment';

/** Leave dates are calendar dates; never shift them through UTC serialization. */
export function leaveDate(
  value: Date | string | null | undefined
): Date | null {
  const date =
    value instanceof Date
      ? moment(value).startOf('day')
      : moment(value?.slice(0, 10), 'YYYY-MM-DD', true);
  return date.isValid() && date.year() >= 1753 ? date.toDate() : null;
}

export function leaveDates(start: Date | string, end: Date | string): Date[] {
  const first = leaveDate(start);
  const last = leaveDate(end);
  if (!first || !last || first > last) return [];
  const dates: Date[] = [];
  for (const date = first; date <= last; date.setDate(date.getDate() + 1)) {
    dates.push(new Date(date));
  }
  return dates;
}

export function chargeableLeaveDates(
  start: Date | string,
  end: Date | string,
  includeWeekends: boolean,
  holidays: (Date | string)[]
): Date[] {
  const excluded = new Set(holidays.map(value => leaveDate(value)?.getTime()));
  return leaveDates(start, end).filter(
    date =>
      !excluded.has(date.getTime()) &&
      (includeWeekends || (date.getDay() !== 0 && date.getDay() !== 6))
  );
}
